module.exports = __webpack_public_path__ + "img/FAU_STA.e83de39e.jpg";